export default {
  home: '/',
  posts: '/posts',
  search: '/search',
  post: '/post',
  traningTypes: '/treningsformer',
  courses: '/kurs',
  category: '/category'
}
